import React from 'react';
export default () => {
    return <h1>Posts</h1>
}